module.exports = __webpack_public_path__ + "media/images/gallery/constellations/snr_layer_off-de9ae7b684986799395de01b8e7d8811.jpg";